import { getField, updateField } from 'vuex-map-fields'

import category from '../../api/cart/'

// initial state
// shape: [{ id, quantity }]
const state = {
  items: {
    CartsProducts: []
  },
  firstItemCheck: false,
  changingDelivery: false,
  tmpProduct: null,
  tokenId: '',
  preAdd: {}
}

// getters
const getters = {
  getField,
  isFirstItem: (state, getters) => {
    return state.firstItemCheck
  },
  tokenId: (state, getters) => {
    const t = state.tokenId
    if (t !== null && t !== undefined && t !== '') {
      return t
    }

    if (process.browser) {
      return localStorage.getItem('tokenId')
    } else {
      return t
    }
  }
}

// actions
const actions = {
  getCarts ({ commit }) {
    return new Promise((resolve, reject) => {
      category.getCarts()
        .then(res => {
          commit('setCartItems', res)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  clearCart ({ state, commit }) {
    commit('clearCart')
  },
  noneFirstItem ({ state, commit }, data) {
    if (data) {
      this.dispatch('cart/cartPreAdd')
    }
    commit('setFirstItem', data)
  },
  changDelivery ({ state, commit }) {
    this.dispatch('cart/noneFirstItem', true)
    commit('setChangingDelivery', true)
  },
  editDeliveryType ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      category.changeDelivery(data)
        .then(res => {
          this.dispatch('cart/noneFirstItem', false)
          return this.dispatch('cart/getCarts')
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addProductToCart ({ state, commit }, product) {
    if (product.IsQuickOrder === null || product.IsQuickOrder === undefined) {
      product.IsQuickOrder = false
    }
    if ((state.items.CartsProducts == null || state.items.CartsProducts.length < 1)) {
      this.dispatch('cart/noneFirstItem', true)
      commit('setTmpProduct', product)
    } else {
      this.dispatch('cart/noneFirstItem', false)
      commit('setTmpProduct', null)
      category.addCart(product)
        .then(res => {
          return this.dispatch('cart/getCarts')
        })
    }
  },
  addNewCart ({ state, commit }, data) {
    if (state.changingDelivery) {
      return this.dispatch('cart/editDeliveryType', data)
    } else {
      return new Promise((resolve, reject) => {
        category.addNew(data)
          .then(res => {
            category.addCart(state.tmpProduct)
              .then(res => {
                return this.dispatch('cart/getCarts')
              })
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  },
  cartPreAdd ({ state, commit }) {
    return new Promise((resolve, reject) => {
      category.preAdd()
        .then(res => {
          commit('setPreAdd', res)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeCartProduct ({ state, commit }, data) {
    const product = {
      CartsProductId: data.CartsProductId
    }
    return new Promise((resolve, reject) => {
      category.remove(product)
        .then(res => {
          return this.dispatch('cart/getCarts')
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  editCart ({ state, commit }, data) {
    const product = {
      CartsProductId: data.CartsProductId,
      Qty: data.Qty
    }
    const cartItem = state.items.CartsProducts.find(item => item.CartsProductId === data.CartsProductId)
    if (cartItem.Qty === 1 && data.Qty === 1) {
      commit('setProductQty', product)
    } else {
      return new Promise((resolve, reject) => {
        category.edit(product)
          .then(res => {
            commit('setProductQty', product)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  },
  checkout ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      category.checkout(data)
        .then(res => {
          if (process.browser) {
            localStorage.removeItem('tokenId')
          }
          this.dispatch('cart/generateTokenId')
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  generateTokenId ({ state, commit }) {
    if (process.browser) {
      const ti = localStorage.getItem('tokenId')
      if (ti === undefined || ti === null) {
        const t = 'xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/x/g, function (c) {
          var r = Math.random() * 16 | 0
          return r.toString(16)
        })
        commit('setTokenId', t)
      }
    }
  }
}

// mutations
const mutations = {
  updateField,
  setFirstItem (state, isFirst) {
    state.firstItemCheck = isFirst
    state.changingDelivery = false
  },
  setPreAdd (state, res) {
    state.preAdd = res
  },
  clearCart (state) {
    state.items = {
      CartsProducts: []
    }
  },
  setTmpProduct (state, product) {
    state.tmpProduct = product
  },
  setProductQty (state, data) {
    const cartItem = state.items.CartsProducts.find(item => item.CartsProductId === data.CartsProductId)
    cartItem.Qty = data.Qty
    cartItem.SubTotal = cartItem.Qty * cartItem.Price
    const totalPrice = state.items.CartsProducts.map(a => a.SubTotal).reduce(function (prev, curr, idx, arr) {
      return prev + curr
    })
    state.items.SubTotal = totalPrice
    if (state.items.SubTotal < state.items.FreeDeliveryPurchaseAmount) {
      if (state.items.DeliveryType === 1) {
        state.items.DeliveryFee = state.items.StandardDeliveryFee
      } else {
        state.items.DeliveryFee = 0
      }
      state.items.Total = state.items.SubTotal + state.items.DeliveryFee
    } else {
      state.items.Total = state.items.SubTotal
    }
    if (state.items.EnableCashPoints === true) {
      const p = state.items.CashPoints !== null ? state.items.CashPoints : 0
      state.items.WillEarnPoints = Math.round((state.items.SubTotal * p / 100) * 10) / 10
    }
  },
  setChangingDelivery (state, data) {
    state.changingDelivery = data
  },
  setCartItems (state, items) {
    state.items = items
  },
  setTokenId (state, t) {
    if (process.browser) {
      localStorage.setItem('tokenId', t)
    }
    state.tokenId = t
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js